import React from 'react'
import PriceWithSymbol from '../PriceWithSymbol'
import './Price.css'

type PriceProps = {
  prices: any
  showGourmetDiscount?: boolean
  style?: React.CSSProperties
}

function Price({ prices, style, showGourmetDiscount = false }: PriceProps) {
  return (
    <span className='cocunat-Price' style={style}>
      {prices &&
      prices.discounted &&
      prices.price !== prices.discounted &&
      !showGourmetDiscount ? (
        <span className='price-product'>
          <PriceWithSymbol
            amount={prices.price}
            format={prices.format}
            symbol={prices.symbol}
            spanClassName={'strike-price'}
          />
          <PriceWithSymbol
            amount={prices.discounted}
            format={prices.format}
            symbol={prices.symbol}
            spanClassName={'actual-price'}
          />
        </span>
      ) : (
        prices && (
          <span>
            {showGourmetDiscount ? (
              <span className='price-product'>
                <PriceWithSymbol
                  amount={
                    prices.gourmet_product_price
                      ? prices.gourmet_product_price
                      : prices.discounted
                  }
                  format={prices.format}
                  symbol={prices.symbol}
                  spanClassName={'actual-price'}
                />
              </span>
            ) : (
              <span className='price-product'>
                <PriceWithSymbol
                  amount={prices.price}
                  format={prices.format}
                  symbol={prices.symbol}
                  spanClassName={'actual-price'}
                />
              </span>
            )}
          </span>
        )
      )}
    </span>
  )
}

export default Price
